<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Stat from "@/components/widgets/stat";
import Multiselect from "vue-multiselect";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Message Center",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Stat,
    Multiselect,
    ModelListSelect,
  },
  data() {
    return {
      title: "Message Center",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Message Center",
          active: true,
        },
      ],

      // Value from user input for adding position
      data: {
        name: "",
      },
      filteredServices: [],
      messageError: "",
      recieverError: "",
      recieverStaffError: "",
      ServiceError: "",
      categoryError: "",
      recieverGroupError: "",
      messageGroupError: "",
      messageStaffError: "",
      messageServiceError: "",
      sendStaff: {
        message: "",
        recievers: [],
        category: "staff",
      },
      send: {
        message: "",
        recievers: [],
        category: "patients",
      },
      sendGroup: {
        message: "",
        recievers: "null",
        category: "group",
      },
      sendService: {
        message: "",
        category: "null",
        service: "null",
      },
      clientRecievers: 0,
      clientmsg: 0,
      clientSize: 0,
      clientTotal: 0,

      staffRecievers: 0,
      staffmsg: 0,
      staffSize: 0,
      staffTotal: 0,

      groupmsg: 0,
      groupSize: 0,

      servicemsg: 0,
      serviceSize: 0,

      groupotions: [
        { name: "All Staff Members", id: "staff" },
        { name: "All Clients", id: "clients" },
        { name: "Consultation Clients", id: "consult" },
        { name: "Radiology Clients", id: "rad" },
        { name: "Procedure Clients", id: "proc" },
        { name: "Laboratory Clients", id: "lab" },
        { name: "Dental Clients", id: "dental" },
      ],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("messages", ["Messages", "SendStatus", "SmsClients"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
    ]),
    ...mapGetters("auth", ["user_permissions"]),
  },
  mounted() {},
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.notificationtype == "success") {
          this.resetInputs();
          this.resetErrors();
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchPatients: "messages/fetchsmsClients",
      FetchStaff: "staffModule/fetchClinicStaff",
      FetchMessages: "messages/fetchMessageSummary",
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      SendMessage: "messages/sendMessage",
      SendMessageGroup: "messages/sendMessageGroup",
      SendMessageService: "messages/sendMessageService",
    }),
    getValues() {
      this.messageError = "";
      if (this.send.recievers.length < 1) {
        this.recieverError = "Please select a recipient(s)";
      }
      this.clientRecievers = this.send.recievers.length;
      this.clientmsg = this.send.message.length + this.Messages.clinic.length;
      this.clientSize = Math.ceil(this.clientmsg / 156);
      this.clientTotal = this.clientRecievers * this.clientSize;
    },
    getValueStaff() {
      this.messageStaffError = "";
      if (this.sendStaff.recievers.length < 1) {
        this.recieverStaffError = "Please select a recipient(s)";
      }
      this.staffRecievers = this.sendStaff.recievers.length;
      this.staffmsg =
        this.sendStaff.message.length + this.Messages.clinic.length;
      this.staffSize = Math.ceil(this.staffmsg / 156);
      this.staffTotal = this.staffRecievers * this.staffSize;
    },
    getValuesGroup() {
      this.messageGroupError = "";
      if (this.sendGroup.recievers == "null") {
        this.recieverGroupError = "Please select a recipient(s)";
      }
      this.groupmsg =
        this.sendGroup.message.length + this.Messages.clinic.length;
      this.groupSize = Math.ceil(this.groupmsg / 156);
    },
    getValueService() {
      this.messageServiceError = "";
      if (this.sendService.category == "null") {
        this.categoryError = "Please select a Service Category";
      }
      if (this.sendService.service == "null") {
        this.ServiceError = "Please select a Service";
      }
      this.servicemsg =
        this.sendService.message.length + this.Messages.clinic.length;
      this.serviceSize = Math.ceil(this.servicemsg / 156);
    },
    filterCategoryServices() {
      if (this.sendService.category == 1) {
        this.filteredServices = this.consultationServices;
      } else if (this.sendService.category == 2) {
        this.filteredServices = this.radiologyServices;
      } else if (this.sendService.category == 3) {
        this.filteredServices = this.procedureServices;
      } else if (this.sendService.category == 4) {
        this.filteredServices = this.labServices;
      } else if (this.sendService.category == 6) {
        this.filteredServices = this.dentalServices;
      }
    },
    resetErrors() {
      this.recieverError = "";
      this.recieverStaffError = "";
      this.recieverGroupError = "";
      this.ServiceError = "";
      this.categoryError = "";
      this.messageError = "";
      this.messageStaffError = "";
      this.messageServiceError = "";
      this.messageGroupError = "";
    },
    resetInputs() {
      this.send.recievers = [];
      this.send.message = "";
      this.sendStaff.recievers = [];
      this.sendStaff.message = "";
      this.sendGroup.recievers = "null";
      this.sendGroup.message = "";
      this.sendService.recievers = "null";
      this.sendService.message = "";
      this.sendService.category = "";
      this.sendService.service = "";
    },
    sendClientMsg() {
      if (this.send.message.length < 1) {
        this.messageError = "Please type the message to send";
        return;
      } else {
        this.messageError = "";
      }
      if (this.send.recievers.length < 1) {
        this.recieverError = "Please select the receipient(s)";
        return;
      } else {
        this.recieverError = "";
      }

      this.SendMessage(this.send);
    },
    sendStaffMsg() {
      if (this.sendStaff.message.length < 1) {
        this.messageStaffError = "Please type the message to send";
        return;
      } else {
        this.messageStaffError = "";
      }
      if (this.sendStaff.recievers.length < 1) {
        this.recieverStaffError = "Please select the receipient(s)";
        return;
      } else {
        this.recieverStaffError = "";
      }

      this.SendMessage(this.sendStaff);
    },
    sendGroupMsg() {
      if (this.sendGroup.message.length < 1) {
        this.messageGroupError = "Please type the message to send";
        return;
      } else {
        this.messageGroupError = "";
      }
      if (this.sendGroup.recievers.length < 1) {
        this.recieverGroupError = "Please select the receipient(s)";
        return;
      } else {
        this.recieverGroupError = "";
      }

      this.SendMessageGroup(this.sendGroup);
    },

    sendServiceMsg() {
      if (this.sendService.message.length < 1) {
        this.messageServiceError = "Please type the message to send";
        return;
      } else {
        this.messageServiceError = "";
      }
      if (this.sendService.category == "null") {
        this.categoryError = "Please select a service category";
        return;
      } else {
        this.categoryError = "";
      }
      if (this.sendService.service == "null") {
        this.ServiceError = "Please select a service group";
        return;
      } else {
        this.ServiceError = "";
      }

      this.SendMessageService(this.sendService);
    },
  },
  created() {
    this.FetchPatients();
    this.FetchStaff();
    this.FetchMessages();
    this.FetchLabServices();
    this.FetchConsultationServices();

    setTimeout(() => {
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchRadiologyServices();
    }, 2000);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row mb-3">
      <div class="col-12">
        <div class="row mb-3 justify-content-around">
          <div
            class="col-3"
            style="border: 3px solid white; padding: 15px; border-radius: 5px"
          >
            <h4 class="text-primary">Message Statics</h4>
            <div>
              <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                <Stat
                  :icon="'fa fa-comments'"
                  :title="'Message Balance'"
                  :value="Messages ? Messages.smsBalance : 0"
                  :extra="'SMS'"
                />
              </div>
              <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                <Stat
                  :icon="'fa fa-comments'"
                  :title="'Message Balance'"
                  :value="Messages ? Messages.smsBalance : 0"
                  :extra="'SMS'"
                />
              </div>
            </div>
          </div>
          <div
            class="col-8"
            style="border: 3px solid white; padding: 15px; border-radius: 5px"
          >
            <div class="row">
              <h4 class="text-primary">Message Categories</h4>

              <div class="col-md-4">
                <router-link
                  :to="{
                    name: 'MessageLogs',
                    params: {
                      category: 'patients',
                    },
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-comments'"
                      :title="'Client Messages'"
                      :value="Messages ? Messages.patientSMS : '0'"
                      :extra="'SMS'"
                    />
                  </div>
                </router-link>
              </div>

              <div class="col-md-4">
                <router-link
                  :to="{
                    name: 'MessageLogs',
                    params: {
                      category: 'staff',
                    },
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-comments'"
                      :title="'Staff Messages'"
                      :value="Messages ? Messages.staffSMS : '0'"
                      :extra="'SMS'"
                    />
                  </div>
                </router-link>
              </div>

              <div class="col-md-4">
                <router-link
                  :to="{
                    name: 'MessageLogs',
                    params: {
                      category: 'others',
                    },
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-comments'"
                      :title="'Other Messages'"
                      :value="Messages ? Messages.othersSMS : '0'"
                      :extra="'SMS'"/>
                  </div>
                </router-link>
              </div>
              <div class="col-md-4">
                <router-link
                  :to="{
                    name: 'PurchaseLogs',
                  }"
                >
                  <div style="box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px">
                    <Stat
                      :icon="'fa fa-eye'"
                      :title="'Purchase Logs'"
                      :value="'0'"
                      :extra="'Times'"
                    />
                  </div>
                </router-link>
              </div>

              <div class="col-4"></div>
              <div class="col-4">
                <router-link
                  :to="{
                    name: 'MessageCenterBuy',
                  }"
                >
                  <button class="btn btn-primary float-end">
                    <i class="fa fa-plus"></i> Buy Messages
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="text-success">Send Messages</h4>
                    <hr />
                    <b-tabs
                      justified
                      nav-class="nav-tabs-custom"
                      content-class="p-3 text-muted"
                    >
                      <b-tab active>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            SMS CLIENTS
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >SMS TO CLIENTS</span
                          >
                        </template>
                        <p>Send Messages to the specified client</p>
                        <div class="row">
                          <div class="col-4">
                            <label>Select Client(s)</label>
                            <multiselect
                              v-model="send.recievers"
                              :height="300"
                              :options="SmsClients ? SmsClients : []"
                              :multiple="true"
                              :taggable="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              tag-placeholder="Add Reciepient"
                              placeholder="Choose Recievers"
                              label="patient_name"
                              track-by="id"
                              @input="resetErrors(), getValues()"
                              :preselect-first="false">
                              <template
                                slot="selection"
                                slot-scope="{ values, isOpen }"
                                ><span
                                  class="multiselect__single"
                                  v-if="values.length &amp;&amp; !isOpen"
                                  >{{ values.length }} Clients selected</span
                                ></template
                              >
                            </multiselect>
                            <span v-if="recieverError" class="text-danger">{{
                              recieverError
                            }}</span>
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{
                                    Messages ? Messages.clinic : "---"
                                  }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="send.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValues()"
                                ></textarea>
                                <div v-if="messageError" class="text-danger">
                                  Please enter a message to send.
                                </div>
                                <div
                                  v-if="send.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ clientmsg }} |
                                  <strong>Size:</strong> {{ clientSize }} |
                                  <strong>Recievers:</strong>
                                  {{ clientRecievers }} |
                                  <strong>Total SMS:</strong> {{ clientTotal }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button
                              v-if="user_permissions.send_messages"
                              @click="sendClientMsg()"
                              class="btn btn-primary"
                            >
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            SMS STAFF
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >SMS TO STAFF</span
                          >
                        </template>
                        <p>Send Messages to the specified staff Member(s)</p>
                        <div class="row">
                          <div class="col-4">
                            <label>Select Staff Member(s)</label>
                            <multiselect
                              v-model="sendStaff.recievers"
                              :height="300"
                              :options="clinic_staff ? clinic_staff : []"
                              :multiple="true"
                              :taggable="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              tag-placeholder="Add Reciepient"
                              placeholder="Choose Recievers"
                              label="staffName"
                              track-by="id"
                              @input="resetErrors(), getValueStaff()"
                              :preselect-first="false"
                            >
                              <template
                                slot="selection"
                                slot-scope="{ values, isOpen }"
                                ><span
                                  class="multiselect__single"
                                  v-if="values.length &amp;&amp; !isOpen"
                                  >{{ values.length }} Staff Member(s)
                                  selected</span
                                ></template
                              >
                            </multiselect>
                            <span
                              v-if="recieverStaffError"
                              class="text-danger"
                              >{{ recieverStaffError }}</span
                            >
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{
                                    Messages ? Messages.clinic : "---"
                                  }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="sendStaff.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValueStaff()"
                                ></textarea>
                                <span
                                  v-if="messageStaffError"
                                  class="text-danger"
                                  >Please enter a message.</span
                                >
                                <div
                                  v-if="sendStaff.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ staffmsg }} |
                                  <strong>Size:</strong> {{ staffSize }} |
                                  <strong>Recievers:</strong>
                                  {{ staffRecievers }} |
                                  <strong>Total SMS:</strong> {{ staffTotal }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button
                              v-if="user_permissions.send_messages"
                              @click="sendStaffMsg()"
                              class="btn btn-primary"
                            >
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            SMS GROUPS
                          </span>
                          <span class="d-none d-sm-inline-block"
                            >SMS TO GROUPS</span
                          >
                        </template>
                        <p>Send Messages to Groups of people</p>
                        <div class="row">
                          <div class="col-4">
                            <label>Select Group</label>
                            <model-list-select
                              @input="resetErrors(), getValuesGroup()"
                              :list="groupotions"
                              v-model="sendGroup.recievers"
                              option-value="id"
                              option-text="name"
                              placeholder="Select Department"
                            >
                            </model-list-select>
                            <span class="text-danger" v-if="recieverGroupError"
                              >Please select the recipient group</span
                            >
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{
                                    Messages ? Messages.clinic : "---"
                                  }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="sendGroup.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValuesGroup()"
                                ></textarea>
                                <div
                                  v-if="sendGroup.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong> {{ groupmsg }} |
                                  <strong>Size:</strong> {{ groupSize }}
                                </div>
                                <span
                                  v-if="messageGroupError"
                                  class="text-danger"
                                  >Please enter a message.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button
                              v-if="user_permissions.send_messages"
                              @click="sendGroupMsg()"
                              class="btn btn-primary"
                            >
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            SMS OTHER
                          </span>
                          <span class="d-none d-sm-inline-block">OTHERS</span>
                        </template>
                        <p>Send Messages to Other Groups of people</p>
                        <div class="row">
                          <div class="col-4">
                            <div class="form-group">
                              <label>Select Category</label>
                              <model-list-select
                                @input="
                                  resetErrors(),
                                    getValueService(),
                                    filterCategoryServices()
                                "
                                :list="departments"
                                v-model="sendService.category"
                                option-value="id"
                                option-text="name"
                                placeholder="Select Service Category"
                              >
                              </model-list-select>
                              <span class="text-danger" v-if="categoryError"
                                >Please select the service category</span
                              >
                            </div>
                            <label>Select Service</label>
                            <model-list-select
                              @input="resetErrors(), getValueService()"
                              :list="filteredServices"
                              v-model="sendService.service"
                              option-value="id"
                              option-text="serviceName"
                              placeholder="Select Service"
                            >
                            </model-list-select>
                            <span class="text-danger" v-if="ServiceError"
                              >Please select the service</span
                            >
                          </div>
                          <div class="col-4">
                            <div class="mb-3">
                              <label
                                >Message (Will start with:
                                <span class="text-success"
                                  >{{
                                    Messages ? Messages.clinic : "---"
                                  }}:)</span
                                ></label
                              >
                              <div>
                                <textarea
                                  v-model="sendService.message"
                                  class="form-control"
                                  rows="5"
                                  @input="getValueService()"
                                ></textarea>
                                <div
                                  v-if="sendService.message.length > 0"
                                  class="text-success font-size-15"
                                  style="border-bottom: 2px solid #0e8f2d"
                                >
                                  <strong>Characters:</strong>
                                  {{ servicemsg }} | <strong>Size:</strong>
                                  {{ serviceSize }}
                                </div>
                                <span
                                  v-if="messageServiceError"
                                  class="text-danger"
                                  >Please enter a message to be sent.</span
                                >
                              </div>
                            </div>
                          </div>
                          <div class="col-4">
                            <button
                              v-if="user_permissions.send_messages"
                              @click="sendServiceMsg()"
                              class="btn btn-primary"
                            >
                              <i class="fa fa-paper-plane"></i> Send SMS
                              <b-spinner
                                v-if="SendStatus"
                                variant="light"
                                small
                                label="Spinning"
                              ></b-spinner>
                            </button>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
